import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface LandingPageImage {
  id: string;
  page_key: string;
  image_key: string;
  image_url: string | null;
  alt_text: string;
  placeholder_icon: string | null;
  placeholder_text: string | null;
}

export const useLandingPageImages = (pageKey: string) => {
  const [images, setImages] = useState<Record<string, LandingPageImage>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const { data, error } = await supabase
          .from("landing_page_images")
          .select("*")
          .eq("page_key", pageKey);

        if (error) {
          console.error("Error fetching landing page images:", error);
          return;
        }

        const imageMap: Record<string, LandingPageImage> = {};
        data?.forEach((img) => {
          imageMap[img.image_key] = img as LandingPageImage;
        });
        setImages(imageMap);
      } catch (err) {
        console.error("Error fetching landing page images:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, [pageKey]);

  const getImage = (imageKey: string): LandingPageImage | null => {
    return images[imageKey] || null;
  };

  const getAllImages = (): LandingPageImage[] => {
    return Object.values(images);
  };

  return { images, loading, getImage, getAllImages };
};
